import level_0 from "./level_0";
import level_1 from "./level_1";
import level_2 from "./level_2";


const levels = [
    level_0,
    level_1,
    // level_2
]

export default levels;